import { textDisclosure } from '../download-data-styles';
import { renderRowGaps } from '../helpers';
import { filterOutUnorderedListTags } from './disclosureHelpers';

/**
 * Render a styled disclosure row with a symbol/number (if assigned), and the disclosure text
 * @param {*} disclosure Object containing dislcosure text and symbol assigned
 */
export const renderDisclosureRow = disclosure => {
  if (disclosure.text.includes(`<ul>`)) {
    disclosure.text = filterOutUnorderedListTags(disclosure.text);
  }
  return `
		<tr>
			<td style="${textDisclosure}">${disclosure.symbolAssigned || ''}</td>
			<td style="${textDisclosure}">${disclosure.text}</td>
		</tr>
	`;
};

/**
 * Renders a gap row depending if next disclosure is a numbered, non-numbered, etc
 * @param {*} nonNumbertoNonNumberGap True if gap is non numbered to non numbered row
 * @param {*} nonNumberToNumberGap True if gap is non number to numbered row
 * @param {*} numberToNonNumber True if gap is numered to non numbered
 */
export const renderDisclosureRowGaps = (nonNumbertoNonNumberGap, nonNumberToNumberGap, numberToNonNumber) => {
  let result = ''; //Return no row gaps if "number to number"
  if (nonNumbertoNonNumberGap) {
    result = renderRowGaps(1);
  } else if (numberToNonNumber || nonNumberToNumberGap) {
    result = renderRowGaps(2);
  }
  return result;
};
